import * as utils from '@intrasync/utils';
import MaterialDialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
// import { PureComponent } from 'react';
import Draggable from 'react-draggable';

import Transition, { TransitionProps } from './DialogTransition';
import injectStores from 'components/RootStore/injectStores';
import type { RouterStore } from 'stores/RouterStore';
import type RootStore from 'stores/RootStore';
import type ViewStore from 'stores/ViewStore';

// import style from './dialogStyle';
interface DialogContainerProps {
  routerStore?: RouterStore;
  viewStore?: ViewStore;
  children: React.ReactNode;
  rootStore?: RootStore;
}

interface PaperComponentProps {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}
// import style from './dialogStyle';
const DialogContainer = injectStores(
  ({ children, routerStore }: DialogContainerProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (!routerStore) return null;
    const {
      renderDialog,
      dialogFullScreen,
      dialogEnableDraggable,
      dialogCloseFunction,
    } = routerStore;

    if (!renderDialog) return null;

    const isFullScreen = dialogFullScreen || isMobile;

    const PaperComponent: React.FC<PaperComponentProps> = (props) => {
      if (!dialogEnableDraggable || isMobile) {
        return <Paper {...props} />;
      }
      return (
        <Draggable handle="#draggable-dialog-title">
          <Paper {...props} />
        </Draggable>
      );
    };

    return (
      <MaterialDialog
        id={utils.uuid()}
        maxWidth={renderDialog.smallDialog ? 'sm' : 'xl'}
        fullWidth={renderDialog.fullWidth ? true : false}
        fullScreen={isFullScreen}
        open={true}
        keepMounted={false}
        onClose={() => dialogCloseFunction()}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
      >
        {children}
      </MaterialDialog>
    );
  }
);

export default DialogContainer;
